const BIAS = {
  NONE: 'NO_BIAS',
  COMPATIBLE: 'COMPATIBLE',
  INCOMPATIBLE: 'INCOMPATIBLE'
}

export default BIAS
